export function normalizeClientWebsite(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }
  if (!/^https?:\/\//i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  return trimmed;
}

export function isValidClientWebsite(value: string): boolean {
  const normalized = normalizeClientWebsite(value);
  if (!normalized) {
    return true;
  }
  try {
    const url = new URL(normalized);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}
